import { apiEmpleo } from "../../util/ApiEmpleo";
import { VALORACION_DESCARTADO } from "../../util/defaults/valoracion";

/**
 * Moves a valuation to "Descartado" with its discard reason. The reason goes in
 * a PATCH because `cuideo_discard_reason` is only writable in the
 * `valoracion-put` group, not on creation.
 */
export const apiDiscardValuation = async (
  valuationId: string,
  reason: string
) => {
  const res = await apiEmpleo.patch(
    `valoraciones/${valuationId}`,
    {
      Estado_en_proceso: VALORACION_DESCARTADO,
      cuideo_discard_reason: reason,
    },
    {
      headers: {
        "Content-Type": "application/merge-patch+json",
      },
    }
  );

  return res;
};
